var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.409 18.913C.564 18.913 0 18.275 0 17.278V1.765C0 .768.564.13 1.409.13c.458 0 .833.163 1.315.43L15.72 7.99c.94.534 1.28.916 1.28 1.53 0 .615-.34.998-1.28 1.531L2.724 18.484c-.482.267-.857.429-1.315.429Z",
    fill: "#fff"
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='17' height='19' viewBox='0 0 17 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M1.40884 18.913C0.56354 18.913 0 18.2753 0 17.2782V1.76516C0 0.768051 0.56354 0.130371 1.40884 0.130371C1.86671 0.130371 2.2424 0.292695 2.72376 0.559355L15.7203 7.99121C16.6595 8.52453 17 8.90717 17 9.52168C17 10.1362 16.6595 10.5188 15.7203 11.0521L2.72376 18.484C2.2424 18.7506 1.86671 18.913 1.40884 18.913Z' fill='white'/%3E %3C/svg%3E";